export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortState<T> = {
  sortBy: T;
  sortOrder: SortOrder;
};
